import type { Infer } from 'superstruct';
import { array, number, object, string } from 'superstruct';

import {
	parsableInteger,
	stringDate,
	withMessage,
} from '@adflow/shared/util-superstruct';

export const UploadGMBTemplateJobData = object({
	templateId: withMessage(parsableInteger(), 'validations:Required'),
	userId: withMessage(parsableInteger(), 'validations:Required'),
});

export const UploadGMBTemplateAccountJobReport = object({
	locationId: number(),
	avbId: string(),
	googleId: string(),
	location: string(),
	status: string(),
	errors: array(string()),
});

export type UploadGMBTemplateAccountJobReport = Infer<
	typeof UploadGMBTemplateAccountJobReport
>;

export const UploadGMBTemplateJobReport = object({
	templateId: number(),
	startedAt: stringDate(),
	finishedAt: stringDate(),
	results: array(UploadGMBTemplateAccountJobReport),
});

export type UploadGMBTemplateJobReport = Infer<
	typeof UploadGMBTemplateJobReport
>;

export type UploadGMBTemplateJobData = Infer<typeof UploadGMBTemplateJobData>;
